export enum EmailProviderTypeEnum {
  SendGrid = 1,
  Office365 = 2
}
